"use client";

import dynamic from "next/dynamic";

const LanguageChangeBanner = dynamic(() => import("./LanguageChangeBanner"));
export default LanguageChangeBanner;
